const Utils = {

    debounce (func, wait, immediate) {
        var timeout;
        wait = wait ? wait : 1000 / 60;
    
        return function (...args) {
            const context = this;
            const later = () => {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            const callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    },
    
    loadImage (src) {
        return new Promise((resolve, reject) => {
            let img = new Image();
            img.onload  = () => { resolve(img) };
            img.onerror = () => { resolve(img) };
            img.src = src;
        });
    },

    randomIndex (array) { return Math.floor(Math.random() * array.length); },

    updateUrl (url) {
        history.pushState(null, '', url);
    }
};

export { Utils as default };
